<template>
  <div class="position-relative">

    <b-dropdown
      id="directory-field-actions-dropdown"
      dropleft
      variant="transparent"
      no-caret
      :disabled="!!!bucketEnums"
    >
      <template #button-content>
        <GjIcon
          name="Moreoptions"
          class="m-0"
        />
      </template>
      <b-dropdown-item
        class="directory-field-actions-item"
        :disabled="!isAvailable"
        @click="$emit('open')"
      >
        <GjIcon name="Files" />
        Files
      </b-dropdown-item>
      <b-dropdown-item
        class="directory-field-actions-item"
        :disabled="!isAvailable"
        @click="$emit('settings')"
      >
        <GjIcon name="Settings" />
        Settings
      </b-dropdown-item>
      <b-dropdown-item
        class="directory-field-actions-item"
        variant="danger"
        :disabled="!isAvailable"
        @click="$emit('delete')"
      >
        <GjIcon name="Delete" />
        Delete
      </b-dropdown-item>
      <b-dropdown-item
        class="directory-field-actions-item"
        variant="danger"
        :disabled="!isAvailable"
        @click="$emit('empty')"
      >
        <GjIcon name="MinusAlt" />
        Empty
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'BucketActions',
  props: {
    bucketStatus: {
      type: String,
      default: null,
    },
    bucketEnums: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isAvailable() {
      return this.bucketStatus === null
      // if (this.bucketStatus !== undefined && this.bucketStatus !== null && this.bucketEnums.jobStatusOptions) {
      //   return this.bucketStatus === this.bucketEnums.jobStatusOptions.Available
      // }
      // return false
    },
  },
}
</script>

<style scoped>
  .directory-field-actions-item{
    width:160px;
  }
</style>
